import clsx from "clsx"
import { Settings } from "../Settings"
import Text from "./common/Text"

const providerImage = {
  Google: "/Google.webp",
  Discord: "/Discord.webp",
  Apple: "/Apple.webp",
  Facebook: "/Facebook.webp"
}

export type OIDCButtonProps = {
  providerId: string
  providerName: string
  authorizationEndpoint: string
  redirectUri: string
  clientId: string
  scopes: string[]
} & React.HTMLAttributes<HTMLDivElement>

function OIDCButton({
  providerId,
  providerName,
  clientId,
  authorizationEndpoint,
  redirectUri,
  scopes = [],

  className,
  ...rest
}: OIDCButtonProps) {

  async function OIDCLogin() {
    const res = await fetch(`${Settings.app.apiOrigin}/api/oidc/providers/${providerId}/challenges`, {
      method: "POST",
      credentials: Settings.fetch.credentials
    })

    const code = await res.text()
    const params = new URLSearchParams({
      response_type: "code",
      client_id: clientId,
      redirect_uri: redirectUri,
      scope: scopes.join(" "),
      code_challenge: code,
      code_challenge_method: "S256"
    })

    const authnUri = `${authorizationEndpoint}?${params.toString()}`
    window.location.href = authnUri
  }

  return (
    <div className={clsx("flex flex-col justify-center items-center",
      "w-24 h-16 sm:w-28 sm:h-20 lg:w-36 lg:h-28",
      "border-2 border-black hover:border-accent-light rounded-lg ring-2 ring-inset ring-white ring-opacity-25",
      "bg-gradient-black-gray hover:bg-gradient-blue1"
    )}
      onClick={OIDCLogin}
      {...rest}
    >
      <img src={providerImage[providerName]} alt={providerName} className="w-6 h-6 sm:w-9 sm:h-9 lg:w-12 lg:h-12" />
      <Text className="font-bold text-center text-xs sm:text-sm md:text-base lg:text-lg text-white">{providerName}</Text>
    </div>
  )
}

export default OIDCButton;